<script lang="ts">
import { metricEventTypes } from "@/lib";
import {mapActions} from "vuex";
import RichText from "@/components/ui/RichText.vue";


export default {
  name: "SectionContent",
  components: {
    RichText,
  },
  props: {
    Titel: {
      type: String,
      required: false
    },
    Text: {
      type: String,
      required: false
    },
    Bilder: {
      type: Array,
      required: false,
      default: () => []
    },
    Medien: {
      type: Array,
      required: false,
      default: () => []
    },
    YoutubeIFrame: {
      type: String,
      required: false
    }
  },
  computed: {
    material() {
      return this.$store.getters["bildungsportal/getMaterialById"](parseInt(this.$route.params.id));
    },
    sanitizedIframe() {
      return this.YoutubeIFrame
          ? this.YoutubeIFrame
              .replace(/<script.*?>.*?<\/script>/gis, '') // remove width and height attributes
          : '';
    }
  },
  methods: {
    ...mapActions("metrics", ["postHeartbeat"]),
    generateDownloadLink(file) {
      return file.url ? process.env.VUE_APP_API_BASE_URL + file.url : '';
    },
    async onDownloadClick(file) {
      console.log(this.material)
      await this.postHeartbeat({
        name: file.name,
        parent: this.material.Titel,
        type: metricEventTypes.FILE_DOWNLOAD,
        data: {
          bildungsportalMetric: true,
        }
      });
    }
  }
}
</script>

<template>
<div>
  <div v-if="Titel" class="new-font-bold">{{ Titel }}</div>
  <rich-text v-if="Text" :source="Text"></rich-text>
  <div v-if="Bilder.length > 0">
    <v-img class="mb-2" v-for="bild of Bilder" :key="bild.id" :src="generateDownloadLink(bild.File)" />
  </div>
  <div v-if="sanitizedIframe" class="centered-iframe mx-auto my-3" v-html="sanitizedIframe"></div>
  <div v-if="Medien.length > 0">
      <div v-for="file in Medien" :key="file.id" class="media-card pa-2 mb-2">
        <div v-if="file.mime.startsWith('image/')">
          <v-img :src="generateDownloadLink(file)" />
          <div v-if="file.caption" class="picture-caption">{{ file.caption }}</div>
        </div>
        <p class="font-weight-bold media-card-title">{{ file.name.replace(file.ext, '') }}</p>
        <p class="mb-1">{{ file.ext.replace(".", "").toUpperCase() }} Dokument (<span class="font-weight-bold">{{ file.size }} KB</span>)</p>
        <div class="d-flex flex-row justify-end">
          <v-btn text small color="primary" :href="generateDownloadLink(file)" target="_blank" @click="onDownloadClick(file)">
            Herunterladen
            <v-icon right>mdi-arrow-down</v-icon>
          </v-btn>
        </div>
      </div>
  </div>
</div>
</template>

<style scoped>
.centered-iframe {
  display: flex;
  justify-content: center;
}

.centered-iframe iframe {
  display: block;
  max-width: 100%;
}

.media-card {
  border-radius: 5px;
  background: rgb(235, 217, 227);
  width: 100%;
}

.media-card p {
  font-size: 14px;
}

.media-card-title {
  color: #B40055;
  margin: 0;
}

.button-container {
  display: flex;
  justify-content: center;
}
</style>
